import { render, staticRenderFns } from "./scanCodePage.vue?vue&type=template&id=2e0120a4&scoped=true&"
import script from "./scanCodePage.vue?vue&type=script&lang=js&"
export * from "./scanCodePage.vue?vue&type=script&lang=js&"
import style0 from "./scanCodePage.vue?vue&type=style&index=0&id=2e0120a4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0120a4",
  null
  
)

export default component.exports